import Box from '@mui/material/Box'
import React from 'react'
import {FolderOff} from '@mui/icons-material'

type NoDataProps = {
    message?: string
}

const NoData = ({message = 'No data'}: NoDataProps) => {
    return (
        <Box
            paddingTop="5em"
            bgcolor="#edf6f9"
            width="100%"
            alignItems="center"
            justifyContent="center"
            display="flex"
            flexDirection="column">
            <FolderOff sx={{fontSize: 70}} />
            <h2>{message}</h2>
        </Box>
    )
}

export default NoData